export default "__VITE_ASSET__b7dde303__"